(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shineneon-homepage-v2"] && !Shopify.designMode) return;
  try {
    const snLoadVideoPoster = video => {
    if (!video.dataset.snVideoPoster) return;
    video.poster = video.dataset.snVideoPoster;
    delete video.dataset.snVideoPoster;
  };
  const snVideoPosterObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      snLoadVideoPoster(entry.target);
      snVideoPosterObserver.unobserve(entry.target);
    });
  }, { rootMargin: '300px 0px' }) : null;
  const snObserveVideoPosters = root => {
    root.querySelectorAll('[data-sn-video-poster]').forEach(video => {
      if (snVideoPosterObserver) snVideoPosterObserver.observe(video);
      else snLoadVideoPoster(video);
    });
  };
  snObserveVideoPosters(document);
  document.addEventListener('shopify:section:load', event => snObserveVideoPosters(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-sn-video-poster]').forEach(video => snVideoPosterObserver?.unobserve(video));
  });
  const snRuntimeRoot = document.querySelector("[data-sn-v2-script-url]");
  if (snRuntimeRoot && !document.querySelector("script[data-sn-v2-runtime]")) {
    const script = document.createElement("script");
    script.dataset.snV2Runtime = "true";
    script.src = snRuntimeRoot.dataset.snV2ScriptUrl;
    script.defer = true;
    document.head.appendChild(script);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sn-business-collection"] && !Shopify.designMode) return;
  try {
    function snBusinessMatches(product, state) {
  const price = Number(product.priceRange.minVariantPrice.amount);
  if (state.min !== '' && price < Number(state.min)) return false;
  if (state.max !== '' && price > Number(state.max)) return false;
  const options = product.options || [];
  if (state.sizes.length) {
    const sizes = options.filter(option => /size|dimension|diameter|length|width|height/i.test(option.name)).flatMap(option => option.optionValues.map(value => value.name));
    const matchesSize = sizes.some(value => {
      let inches = [...value.matchAll(/(\d+(?:\.\d+)?)\s*(?:inches|inch|in\b|["″])/gi)].map(match => Number(match[1]));
      const dimensions = value.match(/(\d+(?:\.\d+)?)\s*[x×*]\s*(\d+(?:\.\d+)?)\s*(?:inches|inch|in\b|["″])/i);
      if (dimensions) inches.push(Number(dimensions[1]), Number(dimensions[2]));
      if (!inches.length) inches = [...value.matchAll(/(\d+(?:\.\d+)?)\s*cm/gi)].map(match => Number(match[1]) / 2.54);
      if (!inches.length) return false;
      const longest = Math.max(...inches);
      return state.sizes.includes(longest <= 24 ? 'small' : longest < 40 ? 'medium' : 'large');
    });
    if (!matchesSize) return false;
  }
  return true;
}

if (!customElements.get('sn-business-collection')) {
  customElements.define('sn-business-collection', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-business-config]').textContent);
      this.events = new AbortController();
      this.cache = new Map();
      this.sourceCache = new Map();
      this.canUseInitial = !new URL(location.href).searchParams.has('page') && !new URL(location.href).searchParams.has('sort_by');
      this.initialContent = this.querySelector("[data-business-content]").cloneNode(true);
      this.sequence = 0;
      this.content = this.querySelector('[data-business-content]');
      this.status = this.querySelector('[data-business-status]');
      this.drawer = this.querySelector('dialog');
      this.openButton = this.querySelector('[data-business-open]');
      this.state = this.readState();
      const options = { signal: this.events.signal };
      this.addEventListener('click', event => {
        const category = event.target.closest('[data-business-category]');
        if (category) {
          this.state.category = category.dataset.businessCategory;
          this.run();
          return;
        }
        const page = event.target.closest('[data-business-page]');
        if (page) {
          event.preventDefault();
          this.run({ page: Number(page.dataset.businessPage), history: false, scroll: true });
          return;
        }
        if (event.target.closest('[data-business-clear]')) {
          this.state = { ...this.state, q: '', min: '', max: '', sizes: [] };
          this.run();
        }
        if (event.target.closest('[data-business-retry]')) this.run({ history: false });
        if (event.target.closest('[data-business-open]')) {
          this.previousOverflow = document.body.style.overflow;
          this.drawer.showModal();
          document.body.style.overflow = 'hidden';
          this.openButton.setAttribute('aria-expanded', 'true');
        }
        if (event.target.closest('[data-business-close]')) this.drawer.close();
      }, options);
      this.addEventListener('submit', event => {
        const form = event.target;
        event.preventDefault();
        if (form.matches('[data-business-search]')) this.state.q = form.querySelector('input[type="search"]').value.trim();
        if (form.matches('[data-business-refine]')) {
          const min = form.querySelector('[data-business-min]');
          const max = form.querySelector('[data-business-max]');
          max.setCustomValidity('');
          if (min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value)) {
            max.setCustomValidity(this.config.messages.invalidRange);
            max.reportValidity();
            return;
          }
          this.state.min = min.value;
          this.state.max = max.value;
        }
        this.run();
      }, options);
      this.addEventListener('change', event => {
        const input = event.target;
        if (input.matches('[data-business-sort]')) {
          this.state.sort = input.value;
          this.run();
        }
        if (input.matches('[data-business-size]')) {
          const form = input.closest('[data-business-refine]');
          this.state.sizes = [...form.querySelectorAll('[data-business-size]:checked')].map(el => el.value);
          this.run();
        }
      }, options);
      this.addEventListener('input', event => {
        if (event.target.matches('[data-business-min], [data-business-max]')) event.target.closest('form').querySelector('[data-business-max]').setCustomValidity('');
      }, options);
      this.querySelector('input[type="search"]').addEventListener('search', event => {
        if (!event.target.value && this.state.q) { this.state.q = ''; this.run(); }
      }, options);
      this.drawer.addEventListener('click', event => {
        if (event.target !== this.drawer) return;
        const rect = this.drawer.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.drawer.close();
      }, options);
      this.drawer.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow || '';
        this.openButton.setAttribute('aria-expanded', 'false');
      }, options);
      window.matchMedia('(min-width: 990px)').addEventListener('change', event => {
        if (event.matches && this.drawer.open) this.drawer.close();
      }, options);
      window.addEventListener('popstate', () => { this.state = this.readState(); this.run({ history: false }); }, options);
      const cleanUrl = new URL(location.href);
      if (cleanUrl.searchParams.has('business_color')) { cleanUrl.searchParams.delete('business_color'); history.replaceState({}, '', cleanUrl); }
      this.run({ history: false, initial: true });
    }
    readState() {
      const params = new URL(location.href).searchParams;
      const category = params.get('business_category');
      const validList = (key, values) => (params.get(key) || '').split(',').filter(value => values.includes(value));
      const validPrice = key => { const value = params.get(key); return value && Number.isFinite(Number(value)) && Number(value) >= 0 ? value : ''; };
      const sort = params.get('business_sort');
      return {
        category: this.config.categories[category] ? category : 'business-neon-sign',
        q: (params.get('business_q') || '').slice(0,120),
        min: validPrice('business_min'), max: validPrice('business_max'),
        sizes: validList('business_size', ['small','medium','large']),
        sort: ['recommended','price-ascending','price-descending','created-descending'].includes(sort) ? sort : 'recommended'
      };
    }
    syncControls() {
      const searching = Boolean(this.state.q);
      if (searching && this.state.sort === 'created-descending') this.state.sort = 'recommended';
      this.querySelectorAll('[data-business-category]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.businessCategory === this.state.category)));
      this.querySelectorAll('[data-business-size]').forEach(input => { input.checked = this.state.sizes.includes(input.value); });
      this.querySelectorAll('[data-business-min]').forEach(input => { input.value = this.state.min; });
      this.querySelectorAll('[data-business-max]').forEach(input => { input.value = this.state.max; });
      this.querySelectorAll('[data-business-sort]').forEach(input => { input.value = this.state.sort; });
      this.querySelectorAll('[data-business-default-sort]').forEach(option => { option.textContent = searching ? this.config.messages.relevance : this.config.messages.recommended; });
      this.querySelectorAll('[data-business-collection-sort]').forEach(option => { option.hidden = searching; option.disabled = searching; });
      const search = this.querySelector('input[type="search"]');
      search.value = this.state.q;
      search.placeholder = this.config.messages.searchPrefix + ' ' + this.categoryLabel().toLowerCase();
      this.querySelector('[data-business-active-category]').textContent = this.categoryLabel();
      const tags = [];
      if (this.state.q) tags.push('“' + this.state.q + '”');
      if (this.state.min !== '' || this.state.max !== '') tags.push(this.config.messages.price + ': ' + (this.state.min || '0') + '–' + (this.state.max || '∞') + ' ' + this.config.currency);
      tags.push(...this.state.sizes.map(value => this.config.sizes[value]));
      this.querySelector('[data-business-active-filters]').textContent = tags.join(' · ');
      this.querySelector('[data-business-toolbar-clear]').hidden = !tags.length;
    }
    categoryLabel() {
      return this.querySelector('[data-business-category="' + this.state.category + '"]').textContent.trim();
    }
    writeState() {
      const url = new URL(location.href);
      const values = { category: this.state.category === 'business-neon-sign' ? '' : this.state.category, q: this.state.q, min: this.state.min, max: this.state.max, size: this.state.sizes.join(','), sort: this.state.sort === 'recommended' ? '' : this.state.sort };
      url.searchParams.delete('business_color');
      for (const [key,value] of Object.entries(values)) {
        if (value) url.searchParams.set('business_' + key, value); else url.searchParams.delete('business_' + key);
      }
      url.searchParams.delete('page');
      url.searchParams.delete('sort_by');
      if (url.href !== location.href) history.pushState({}, '', url);
    }
    async request(state, after, signal) {
      const sourceKey = JSON.stringify({ ...state, sizes: [], after });
      if (this.sourceCache.has(sourceKey)) return this.sourceCache.get(sourceKey);
      const searching = Boolean(state.q);
      const filters = [];
      if (state.min !== '' || state.max !== '') {
        const price = {};
        if (state.min !== '') price.min = Number(state.min);
        if (state.max !== '') price.max = Number(state.max);
        filters.push({ price });
      }
      let sort = 'BEST_SELLING';
      if (searching) sort = 'RELEVANCE';
      if (state.sort.startsWith('price-')) sort = 'PRICE';
      if (!searching && state.sort === 'created-descending') sort = 'CREATED';
      const reverse = state.sort === 'price-descending' || state.sort === 'created-descending';
      const variables = { after, filters, sort, reverse, country: this.config.country };
      if (searching) {
        const terms = state.q.match(/[\p{L}\p{N}]+/gu) || [];
        const words = terms.length ? terms.map(word => '"' + word + '"').join(' AND ') : '"' + state.q.replace(/["\\]/g, '') + '"';
        variables.query = '(' + this.config.categories[state.category] + ') AND (' + words + ')';
      } else variables.handle = state.category;
      const response = await fetch(this.config.api, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ query: searching ? this.config.searchQuery : this.config.collectionQuery, variables }), signal: AbortSignal.any([signal, AbortSignal.timeout(8000)]) });
      if (!response.ok) throw new Error('Products request failed');
      const data = await response.json();
      if (data.errors?.length) throw new Error('Products query failed');
      const result = searching ? data.data?.search : data.data?.collection?.products;
      if (!result) throw new Error('Products unavailable');
      this.sourceCache.set(sourceKey, result);
      if (this.sourceCache.size > 32) this.sourceCache.delete(this.sourceCache.keys().next().value);
      return result;
    }
    renderPending() {
      const grid = this.element('div', 'sn-business-grid sn-business-skeleton');
      grid.setAttribute('aria-hidden', 'true');
      for (let i = 0; i < 6; i++) {
        const card = this.element('div', 'sn-business-card');
        card.append(this.element('div', 'sn-business-card__image'), this.element('div', 'sn-business-skeleton__line'));
        grid.append(card);
      }
      this.content.replaceChildren(grid);
    }
    async run({ page = 1, history: updateHistory = true, scroll = false, initial = false } = {}) {
      this.pending?.abort();
      clearTimeout(this.loadingTimer);
      const controller = new AbortController();
      this.pending = controller;
      const sequence = ++this.sequence;
      this.syncControls();
      if (updateHistory) this.writeState();
      const state = structuredClone(this.state);
      const key = JSON.stringify(state);
      const isDefault = state.category === 'business-neon-sign' && !state.q && state.min === '' && state.max === '' && !state.sizes.length && state.sort === 'recommended';
      const initialUrl = new URL(location.href);
      if (this.canUseInitial && isDefault && page === 1 && !initialUrl.searchParams.has('page') && !initialUrl.searchParams.has('sort_by')) {
        if (!initial) this.content.replaceChildren(...[...this.initialContent.childNodes].map(node => node.cloneNode(true)));
        this.status.textContent = '';
        this.dataset.loading = 'false';
        this.dataset.notice = 'false';
        this.content.setAttribute('aria-busy', 'false');
        this.querySelector('[data-business-retry]').hidden = true;
        return;
      }
      let record = this.cache.get(key);
      if (!record) {
        record = { products: [], seen: new Set(), after: null, more: true };
        this.cache.set(key, record);
        if (this.cache.size > 8) this.cache.delete(this.cache.keys().next().value);
      }
      const start = (page - 1) * 24;
      const show = () => this.renderProducts(record.products.slice(start, start + 24), page, record.products.length > start + 24 || record.more, record.more && record.products.length < page * 24);
      this.dataset.notice = 'false';
      this.status.textContent = '';
      this.querySelector('[data-business-retry]').hidden = true;
      if (record.products.length > start || !record.more) show(); else this.renderPending();
      this.content.setAttribute('aria-busy', 'true');
      this.dataset.loading = 'true';
      this.loadingTimer = setTimeout(() => {
        if (sequence === this.sequence) this.status.textContent = this.config.messages.loading.replace('__CATEGORY__', this.categoryLabel());
      }, 250);
      const started = performance.now();
      const signal = AbortSignal.any([controller.signal, AbortSignal.timeout(10000)]);
      let batches = 0;
      try {
        while (record.products.length < page * 24 && record.more && batches < 3) {
          const result = await this.request(state, record.after, signal);
          if (sequence !== this.sequence) return;
          for (const product of result.nodes) {
            if (!record.seen.has(product.id) && snBusinessMatches(product, state)) {
              record.seen.add(product.id);
              record.products.push(product);
            }
          }
          record.after = result.pageInfo.endCursor;
          record.more = result.pageInfo.hasNextPage;
          batches++;
          if (record.products.length > start) show();
          if (record.products.length > start && performance.now() - started >= 2500) break;
        }
        if (sequence !== this.sequence) return;
        show();
        const incomplete = record.more && record.products.length < page * 24;
        this.status.textContent = incomplete ? this.config.messages.partial : this.config.messages.updated;
        this.dataset.notice = String(incomplete);
        if (scroll) this.querySelector('.sn-business-results').scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (error) {
        if (sequence !== this.sequence || controller.signal.aborted) return;
        if (record.products.length > start) show(); else this.content.replaceChildren();
        this.status.textContent = this.config.messages.error;
        this.querySelector('[data-business-retry]').hidden = false;
        this.dataset.notice = 'true';
      } finally {
        if (sequence === this.sequence) {
          clearTimeout(this.loadingTimer);
          this.content.setAttribute('aria-busy', 'false');
          this.dataset.loading = 'false';
        }
      }
    }
    element(tag, className, text) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text) element.textContent = text;
      return element;
    }
    renderProducts(products, page, more, incomplete = false) {
      const grid = this.element('div', 'sn-business-grid');
      for (const [index,product] of products.entries()) {
        const card = this.element('article', 'sn-business-card');
        const url = this.config.productRoot + encodeURIComponent(product.handle);
        const picture = this.element('a', 'sn-business-card__image');
        picture.href = url;
        picture.setAttribute('aria-label', product.title);
        if (product.featuredImage) {
          const img = document.createElement('img');
          img.src = product.featuredImage.url;
          img.alt = product.featuredImage.altText || product.title;
          img.width = product.featuredImage.width || 800;
          img.height = product.featuredImage.height || 800;
          img.loading = index < 3 ? 'eager' : 'lazy';
          img.decoding = 'async';
          img.sizes = '(max-width: 767px) calc((100vw - 44px)/2), (max-width: 989px) 31vw, 25vw';
          img.srcset = [320,480,640,800].map(width => { const src = new URL(product.featuredImage.url); src.searchParams.set('width', width); return src.href + ' ' + width + 'w'; }).join(', ');
          picture.append(img);
        }
        const title = this.element('a', 'sn-business-card__title', product.title);
        title.href = url;
        const min = product.priceRange.minVariantPrice;
        const max = product.priceRange.maxVariantPrice;
        const formatted = new Intl.NumberFormat(this.config.locale, { style: 'currency', currency: min.currencyCode }).format(Number(min.amount));
        const price = this.element('p', 'sn-business-card__price', (Number(min.amount) < Number(max.amount) ? this.config.messages.from + ' ' : '') + formatted + ' ' + min.currencyCode);
        card.append(picture, title, price);
        grid.append(card);
      }
      if (!products.length && !incomplete) {
        const empty = this.element('div', 'sn-business-empty');
        empty.append(this.element('h2','',this.config.messages.emptyTitle), this.element('p','',this.config.messages.emptyText));
        const clear = this.element('button', 'sn-business-clear', this.config.messages.clear);
        clear.type = 'button';
        clear.setAttribute('data-business-clear', '');
        empty.append(clear);
        grid.append(empty);
      }
      const nav = this.element('nav', 'sn-business-pagination');
      nav.setAttribute('aria-label', this.config.messages.pagination);
      const pageButton = (number,label) => { const button = this.element('button','',label); button.type = 'button'; button.dataset.businessPage = number; return button; };
      if (page > 1) nav.append(pageButton(page-1,this.config.messages.previous));
      if (page > 1 || more) nav.append(this.element('span','',this.config.messages.page.replace('__PAGE__',String(page))));
      if (incomplete) nav.append(pageButton(page, this.config.messages.continue));
      else if (more) nav.append(pageButton(page+1,this.config.messages.next));
      this.content.replaceChildren(grid,nav);
    }
    disconnectedCallback() {
      this.pending?.abort();
      this.events?.abort();
      clearTimeout(this.loadingTimer);
      if (this.drawer?.open) { this.drawer.close(); document.body.style.overflow = this.previousOverflow || ''; }
      this.initialized = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sn-channel-collection"] && !Shopify.designMode) return;
  try {
    function snChannelMatches(product, state) {
  const price = Number(product.priceRange.minVariantPrice.amount);
  if (state.min !== '' && price < Number(state.min)) return false;
  if (state.max !== '' && price > Number(state.max)) return false;
  const options = product.options || [];
  if (state.sizes.length) {
    const sizes = options.filter(option => /size|dimension|diameter|length|width|height/i.test(option.name)).flatMap(option => option.optionValues.map(value => value.name));
    const matchesSize = sizes.some(value => {
      let inches = [...value.matchAll(/(\d+(?:\.\d+)?)\s*(?:inches|inch|in\b|["″])/gi)].map(match => Number(match[1]));
      const dimensions = value.match(/(\d+(?:\.\d+)?)\s*[x×*]\s*(\d+(?:\.\d+)?)\s*(?:inches|inch|in\b|["″])/i);
      if (dimensions) inches.push(Number(dimensions[1]), Number(dimensions[2]));
      if (!inches.length) inches = [...value.matchAll(/(\d+(?:\.\d+)?)\s*cm/gi)].map(match => Number(match[1]) / 2.54);
      if (!inches.length) return false;
      const longest = Math.max(...inches);
      return state.sizes.includes(longest <= 12 ? 'small' : longest <= 24 ? 'medium' : 'large');
    });
    if (!matchesSize) return false;
  }
  return true;
}

if (!customElements.get('sn-channel-collection')) {
  customElements.define('sn-channel-collection', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-channel-config]').textContent);
      this.events = new AbortController();
      this.cache = new Map();
      this.sourceCache = new Map();
      this.canUseInitial = !new URL(location.href).searchParams.has('page') && !new URL(location.href).searchParams.has('sort_by');
      this.initialContent = this.querySelector("[data-channel-content]").cloneNode(true);
      this.sequence = 0;
      this.content = this.querySelector('[data-channel-content]');
      this.status = this.querySelector('[data-channel-status]');
      this.drawer = this.querySelector('dialog');
      this.openButton = this.querySelector('[data-channel-open]');
      this.state = this.readState();
      const options = { signal: this.events.signal };
      this.addEventListener('click', event => {
        const category = event.target.closest('[data-channel-category]');
        if (category) {
          this.state.category = category.dataset.channelCategory;
          this.run();
          return;
        }
        const page = event.target.closest('[data-channel-page]');
        if (page) {
          event.preventDefault();
          this.run({ page: Number(page.dataset.channelPage), history: false, scroll: true });
          return;
        }
        if (event.target.closest('[data-channel-clear]')) {
          this.state = { ...this.state, q: '', min: '', max: '', sizes: [] };
          this.run();
        }
        if (event.target.closest('[data-channel-retry]')) this.run({ history: false });
        if (event.target.closest('[data-channel-open]')) {
          this.previousOverflow = document.body.style.overflow;
          this.drawer.showModal();
          document.body.style.overflow = 'hidden';
          this.openButton.setAttribute('aria-expanded', 'true');
        }
        if (event.target.closest('[data-channel-close]')) this.drawer.close();
      }, options);
      this.addEventListener('submit', event => {
        const form = event.target;
        event.preventDefault();
        if (form.matches('[data-channel-search]')) this.state.q = form.querySelector('input[type="search"]').value.trim();
        if (form.matches('[data-channel-refine]')) {
          const min = form.querySelector('[data-channel-min]');
          const max = form.querySelector('[data-channel-max]');
          max.setCustomValidity('');
          if (min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value)) {
            max.setCustomValidity(this.config.messages.invalidRange);
            max.reportValidity();
            return;
          }
          this.state.min = min.value;
          this.state.max = max.value;
        }
        this.run();
      }, options);
      this.addEventListener('change', event => {
        const input = event.target;
        if (input.matches('[data-channel-sort]')) {
          this.state.sort = input.value;
          this.run();
        }
        if (input.matches('[data-channel-size]')) {
          const form = input.closest('[data-channel-refine]');
          this.state.sizes = [...form.querySelectorAll('[data-channel-size]:checked')].map(el => el.value);
          this.run();
        }
      }, options);
      this.addEventListener('input', event => {
        if (event.target.matches('[data-channel-min], [data-channel-max]')) event.target.closest('form').querySelector('[data-channel-max]').setCustomValidity('');
      }, options);
      this.querySelector('input[type="search"]').addEventListener('search', event => {
        if (!event.target.value && this.state.q) { this.state.q = ''; this.run(); }
      }, options);
      this.drawer.addEventListener('click', event => {
        if (event.target !== this.drawer) return;
        const rect = this.drawer.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.drawer.close();
      }, options);
      this.drawer.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow || '';
        this.openButton.setAttribute('aria-expanded', 'false');
      }, options);
      window.matchMedia('(min-width: 990px)').addEventListener('change', event => {
        if (event.matches && this.drawer.open) this.drawer.close();
      }, options);
      window.addEventListener('popstate', () => { this.state = this.readState(); this.run({ history: false }); }, options);
      const cleanUrl = new URL(location.href);
      if (cleanUrl.searchParams.has('channel_color')) { cleanUrl.searchParams.delete('channel_color'); history.replaceState({}, '', cleanUrl); }
      this.run({ history: false, initial: true });
    }
    readState() {
      const params = new URL(location.href).searchParams;
      const category = params.get('channel_category');
      const validList = (key, values) => (params.get(key) || '').split(',').filter(value => values.includes(value));
      const validPrice = key => { const value = params.get(key); return value && Number.isFinite(Number(value)) && Number(value) >= 0 ? value : ''; };
      const sort = params.get('channel_sort');
      return {
        category: this.config.categories[category] ? category : 'channel-letter',
        q: (params.get('channel_q') || '').slice(0,120),
        min: validPrice('channel_min'), max: validPrice('channel_max'),
        sizes: validList('channel_size', ['small','medium','large']),
        sort: ['recommended','price-ascending','price-descending','created-descending'].includes(sort) ? sort : 'recommended'
      };
    }
    syncControls() {
      const searching = Boolean(this.state.q);
      if (searching && this.state.sort === 'created-descending') this.state.sort = 'recommended';
      this.querySelectorAll('[data-channel-category]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.channelCategory === this.state.category)));
      this.querySelectorAll('[data-channel-size]').forEach(input => { input.checked = this.state.sizes.includes(input.value); });
      this.querySelectorAll('[data-channel-min]').forEach(input => { input.value = this.state.min; });
      this.querySelectorAll('[data-channel-max]').forEach(input => { input.value = this.state.max; });
      this.querySelectorAll('[data-channel-sort]').forEach(input => { input.value = this.state.sort; });
      this.querySelectorAll('[data-channel-default-sort]').forEach(option => { option.textContent = searching ? this.config.messages.relevance : this.config.messages.recommended; });
      this.querySelectorAll('[data-channel-collection-sort]').forEach(option => { option.hidden = searching; option.disabled = searching; });
      const search = this.querySelector('input[type="search"]');
      search.value = this.state.q;
      search.placeholder = this.config.messages.searchPrefix + ' ' + this.categoryLabel().toLowerCase();
      this.querySelector('[data-channel-active-category]').textContent = this.categoryLabel();
      const tags = [];
      if (this.state.q) tags.push('“' + this.state.q + '”');
      if (this.state.min !== '' || this.state.max !== '') tags.push(this.config.messages.price + ': ' + (this.state.min || '0') + '–' + (this.state.max || '∞') + ' ' + this.config.currency);
      tags.push(...this.state.sizes.map(value => this.config.sizes[value]));
      this.querySelector('[data-channel-active-filters]').textContent = tags.join(' · ');
      this.querySelector('[data-channel-toolbar-clear]').hidden = !tags.length;
    }
    categoryLabel() {
      return this.querySelector('[data-channel-category="' + this.state.category + '"]').textContent.trim();
    }
    writeState() {
      const url = new URL(location.href);
      const values = { category: this.state.category === 'channel-letter' ? '' : this.state.category, q: this.state.q, min: this.state.min, max: this.state.max, size: this.state.sizes.join(','), sort: this.state.sort === 'recommended' ? '' : this.state.sort };
      url.searchParams.delete('channel_color');
      for (const [key,value] of Object.entries(values)) {
        if (value) url.searchParams.set('channel_' + key, value); else url.searchParams.delete('channel_' + key);
      }
      url.searchParams.delete('page');
      url.searchParams.delete('sort_by');
      if (url.href !== location.href) history.pushState({}, '', url);
    }
    async request(state, after, signal) {
      const sourceKey = JSON.stringify({ ...state, sizes: [], after });
      if (this.sourceCache.has(sourceKey)) return this.sourceCache.get(sourceKey);
      const searching = Boolean(state.q);
      const filters = [];
      if (state.min !== '' || state.max !== '') {
        const price = {};
        if (state.min !== '') price.min = Number(state.min);
        if (state.max !== '') price.max = Number(state.max);
        filters.push({ price });
      }
      let sort = 'BEST_SELLING';
      if (searching) sort = 'RELEVANCE';
      if (state.sort.startsWith('price-')) sort = 'PRICE';
      if (!searching && state.sort === 'created-descending') sort = 'CREATED';
      const reverse = state.sort === 'price-descending' || state.sort === 'created-descending';
      const variables = { after, filters, sort, reverse, country: this.config.country };
      if (searching) {
        const terms = state.q.match(/[\p{L}\p{N}]+/gu) || [];
        const words = terms.length ? terms.map(word => '"' + word + '"').join(' AND ') : '"' + state.q.replace(/["\\]/g, '') + '"';
        variables.query = '(' + this.config.categories[state.category] + ') AND (' + words + ')';
      } else variables.handle = state.category;
      const response = await fetch(this.config.api, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ query: searching ? this.config.searchQuery : this.config.collectionQuery, variables }), signal: AbortSignal.any([signal, AbortSignal.timeout(8000)]) });
      if (!response.ok) throw new Error('Products request failed');
      const data = await response.json();
      if (data.errors?.length) throw new Error('Products query failed');
      const result = searching ? data.data?.search : data.data?.collection?.products;
      if (!result) throw new Error('Products unavailable');
      this.sourceCache.set(sourceKey, result);
      if (this.sourceCache.size > 32) this.sourceCache.delete(this.sourceCache.keys().next().value);
      return result;
    }
    renderPending() {
      const grid = this.element('div', 'sn-channel-grid sn-channel-skeleton');
      grid.setAttribute('aria-hidden', 'true');
      for (let i = 0; i < 6; i++) {
        const card = this.element('div', 'sn-channel-card');
        card.append(this.element('div', 'sn-channel-card__image'), this.element('div', 'sn-channel-skeleton__line'));
        grid.append(card);
      }
      this.content.replaceChildren(grid);
    }
    async run({ page = 1, history: updateHistory = true, scroll = false, initial = false } = {}) {
      this.pending?.abort();
      clearTimeout(this.loadingTimer);
      const controller = new AbortController();
      this.pending = controller;
      const sequence = ++this.sequence;
      this.syncControls();
      if (updateHistory) this.writeState();
      const state = structuredClone(this.state);
      const key = JSON.stringify(state);
      const isDefault = state.category === 'channel-letter' && !state.q && state.min === '' && state.max === '' && !state.sizes.length && state.sort === 'recommended';
      const initialUrl = new URL(location.href);
      if (this.canUseInitial && isDefault && page === 1 && !initialUrl.searchParams.has('page') && !initialUrl.searchParams.has('sort_by')) {
        if (!initial) this.content.replaceChildren(...[...this.initialContent.childNodes].map(node => node.cloneNode(true)));
        this.status.textContent = '';
        this.dataset.loading = 'false';
        this.dataset.notice = 'false';
        this.content.setAttribute('aria-busy', 'false');
        this.querySelector('[data-channel-retry]').hidden = true;
        return;
      }
      let record = this.cache.get(key);
      if (!record) {
        record = { products: [], seen: new Set(), after: null, more: true };
        this.cache.set(key, record);
        if (this.cache.size > 8) this.cache.delete(this.cache.keys().next().value);
      }
      const start = (page - 1) * 24;
      const show = () => this.renderProducts(record.products.slice(start, start + 24), page, record.products.length > start + 24 || record.more, record.more && record.products.length < page * 24);
      this.dataset.notice = 'false';
      this.status.textContent = '';
      this.querySelector('[data-channel-retry]').hidden = true;
      if (record.products.length > start || !record.more) show(); else this.renderPending();
      this.content.setAttribute('aria-busy', 'true');
      this.dataset.loading = 'true';
      this.loadingTimer = setTimeout(() => {
        if (sequence === this.sequence) this.status.textContent = this.config.messages.loading.replace('__CATEGORY__', this.categoryLabel());
      }, 250);
      const started = performance.now();
      const signal = AbortSignal.any([controller.signal, AbortSignal.timeout(10000)]);
      let batches = 0;
      try {
        while (record.products.length < page * 24 && record.more && batches < 3) {
          const result = await this.request(state, record.after, signal);
          if (sequence !== this.sequence) return;
          for (const product of result.nodes) {
            if (!record.seen.has(product.id) && snChannelMatches(product, state)) {
              record.seen.add(product.id);
              record.products.push(product);
            }
          }
          record.after = result.pageInfo.endCursor;
          record.more = result.pageInfo.hasNextPage;
          batches++;
          if (record.products.length > start) show();
          if (record.products.length > start && performance.now() - started >= 2500) break;
        }
        if (sequence !== this.sequence) return;
        show();
        const incomplete = record.more && record.products.length < page * 24;
        this.status.textContent = incomplete ? this.config.messages.partial : this.config.messages.updated;
        this.dataset.notice = String(incomplete);
        if (scroll) this.querySelector('.sn-channel-results').scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (error) {
        if (sequence !== this.sequence || controller.signal.aborted) return;
        if (record.products.length > start) show(); else this.content.replaceChildren();
        this.status.textContent = this.config.messages.error;
        this.querySelector('[data-channel-retry]').hidden = false;
        this.dataset.notice = 'true';
      } finally {
        if (sequence === this.sequence) {
          clearTimeout(this.loadingTimer);
          this.content.setAttribute('aria-busy', 'false');
          this.dataset.loading = 'false';
        }
      }
    }
    element(tag, className, text) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text) element.textContent = text;
      return element;
    }
    renderProducts(products, page, more, incomplete = false) {
      const grid = this.element('div', 'sn-channel-grid');
      for (const [index,product] of products.entries()) {
        const card = this.element('article', 'sn-channel-card');
        const url = this.config.productRoot + encodeURIComponent(product.handle);
        const picture = this.element('a', 'sn-channel-card__image');
        picture.href = url;
        picture.setAttribute('aria-label', product.title);
        if (product.featuredImage) {
          const img = document.createElement('img');
          img.src = product.featuredImage.url;
          img.alt = product.featuredImage.altText || product.title;
          img.width = product.featuredImage.width || 800;
          img.height = product.featuredImage.height || 800;
          img.loading = index < 3 ? 'eager' : 'lazy';
          img.decoding = 'async';
          img.sizes = '(max-width: 767px) calc((100vw - 44px)/2), (max-width: 989px) 31vw, 25vw';
          img.srcset = [320,480,640,800].map(width => { const src = new URL(product.featuredImage.url); src.searchParams.set('width', width); return src.href + ' ' + width + 'w'; }).join(', ');
          picture.append(img);
        }
        const title = this.element('a', 'sn-channel-card__title', product.title);
        title.href = url;
        const min = product.priceRange.minVariantPrice;
        const max = product.priceRange.maxVariantPrice;
        const formatted = new Intl.NumberFormat(this.config.locale, { style: 'currency', currency: min.currencyCode }).format(Number(min.amount));
        const price = this.element('p', 'sn-channel-card__price', (Number(min.amount) < Number(max.amount) ? this.config.messages.from + ' ' : '') + formatted + ' ' + min.currencyCode);
        card.append(picture, title, price);
        grid.append(card);
      }
      if (!products.length && !incomplete) {
        const empty = this.element('div', 'sn-channel-empty');
        empty.append(this.element('h2','',this.config.messages.emptyTitle), this.element('p','',this.config.messages.emptyText));
        const clear = this.element('button', 'sn-channel-clear', this.config.messages.clear);
        clear.type = 'button';
        clear.setAttribute('data-channel-clear', '');
        empty.append(clear);
        grid.append(empty);
      }
      const nav = this.element('nav', 'sn-channel-pagination');
      nav.setAttribute('aria-label', this.config.messages.pagination);
      const pageButton = (number,label) => { const button = this.element('button','',label); button.type = 'button'; button.dataset.channelPage = number; return button; };
      if (page > 1) nav.append(pageButton(page-1,this.config.messages.previous));
      if (page > 1 || more) nav.append(this.element('span','',this.config.messages.page.replace('__PAGE__',String(page))));
      if (incomplete) nav.append(pageButton(page, this.config.messages.continue));
      else if (more) nav.append(pageButton(page+1,this.config.messages.next));
      this.content.replaceChildren(grid,nav);
    }
    disconnectedCallback() {
      this.pending?.abort();
      this.events?.abort();
      clearTimeout(this.loadingTimer);
      if (this.drawer?.open) { this.drawer.close(); document.body.style.overflow = this.previousOverflow || ''; }
      this.initialized = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sn-color-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sn-color-preview')) {
    customElements.define('sn-color-preview', class extends HTMLElement {
      connectedCallback() {
        this.cleanup();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.version = 0;
        this.image = this.querySelector('img');
        this.buttons = [...this.querySelectorAll('[data-color]')];
        this.cache = new Map();
        this.displayedButton = this.buttons.find(button => button.getAttribute('aria-pressed') === 'true');
        if (!this.image) return;
        this.sizes = this.image.sizes;
        const warm = () => this.warmColors();
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (!entries.some(entry => entry.isIntersecting)) return;
            this.observer.disconnect();
            warm();
          }, { rootMargin: '1800px 0px' });
          this.observer.observe(this);
        }
        this.warmTimer = setTimeout(warm, 1600);
        this.addEventListener('pointerenter', warm, { once: true, signal });
        this.addEventListener('focusin', warm, { once: true, signal });
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-color]');
          if (button && this.contains(button)) this.selectColor(button);
        }, { signal });
        this.addEventListener('keydown', event => {
          const button = event.target.closest('[data-color]');
          if (!button) return;
          const index = this.buttons.indexOf(button);
          const moves = { ArrowRight: (index + 1) % this.buttons.length, ArrowLeft: (index - 1 + this.buttons.length) % this.buttons.length, Home: 0, End: this.buttons.length - 1 };
          if (!(event.key in moves)) return;
          event.preventDefault();
          const target = this.buttons[moves[event.key]];
          target.focus();
          this.selectColor(target);
        }, { signal });
      }
      warmColors() {
        if (!this.isConnected || this.warmed) return;
        this.warmed = true;
        this.buttons.forEach(button => this.loadColor(button).promise.catch(() => {}));
      }
      loadColor(button, priority = 'low') {
        const cached = this.cache.get(button);
        if (cached) {
          if (priority === 'high') cached.image.fetchPriority = 'high';
          return cached;
        }
        const next = new Image(1448, 1086);
        next.decoding = 'async';
        next.fetchPriority = priority;
        next.sizes = this.sizes;
        next.srcset = button.dataset.srcset;
        next.src = button.dataset.src;
        next.alt = button.dataset.alt;
        const entry = { image: next, ready: false };
        this.cache.set(button, entry);
        entry.promise = next.decode().then(() => {
          entry.ready = true;
          return entry;
        }).catch(error => {
          if (this.cache.get(button) === entry) this.cache.delete(button);
          throw error;
        });
        return entry;
      }
      markSelected(button) {
        this.buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.querySelector('[data-color-name]').textContent = button.dataset.color;
      }
      selectColor(button) {
        const version = ++this.version;
        const status = this.querySelector('[data-color-status]');
        const frame = this.querySelector('.sn-color-preview__media');
        this.markSelected(button);
        const commit = entry => {
          if (version !== this.version || !this.isConnected) return;
          if (this.image !== entry.image) this.image.replaceWith(entry.image);
          this.image = entry.image;
          this.displayedButton = button;
          frame.removeAttribute('aria-busy');
          status.hidden = true;
        };
        if (button === this.displayedButton) {
          frame.removeAttribute('aria-busy');
          status.hidden = true;
          return;
        }
        const entry = this.loadColor(button, 'high');
        if (entry.ready) {
          commit(entry);
          return;
        }
        frame.setAttribute('aria-busy', 'true');
        status.textContent = this.dataset.loadingLabel;
        status.hidden = false;
        entry.promise.then(commit).catch(() => {
          if (version !== this.version || !this.isConnected) return;
          this.markSelected(this.displayedButton);
          status.textContent = this.dataset.errorLabel;
          frame.removeAttribute('aria-busy');
        });
      }
      cleanup() {
        this.controller?.abort();
        this.observer?.disconnect();
        clearTimeout(this.warmTimer);
        this.warmed = false;
        this.version = (this.version || 0) + 1;
      }
      disconnectedCallback() {
        this.cleanup();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sn-secondary-collection"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('sn-secondary-collection')) customElements.define('sn-secondary-collection',class extends HTMLElement {
 connectedCallback(){
  if(this.ready)return;this.ready=true;this.events=new AbortController();this.sequence=0;this.cache=new Map();
  this.messages=JSON.parse(this.querySelector('[data-secondary-config]').textContent);this.content=this.querySelector('[data-secondary-content]');this.initial=this.content.innerHTML;
  this.input=this.querySelector('input[type="search"]');this.sort=this.querySelector('select');this.status=this.querySelector('[data-secondary-status]');this.retry=this.querySelector('[data-secondary-retry]');this.clear=this.querySelector('[data-secondary-clear]');this.initialSort=this.sort.value;this.normalOptions=[...this.sort.options].map(o=>({value:o.value,text:o.textContent}));
  const opt={signal:this.events.signal};this.read();
  this.querySelector('form').addEventListener('submit',e=>{e.preventDefault();this.setMode();this.run(1);},opt);
  this.sort.addEventListener('change',()=>this.run(1),opt);
  this.input.addEventListener('input',()=>{if(!this.input.value){this.setMode();this.run(1);}},opt);
  this.addEventListener('click',e=>{const page=e.target.closest('[data-secondary-page]');if(page){e.preventDefault();this.run(Number(page.dataset.secondaryPage));}if(e.target.closest('[data-secondary-clear]')){this.input.value='';this.setMode();this.run(1);}if(e.target.closest('[data-secondary-retry]'))this.run(this.page);},opt);
  window.addEventListener('popstate',()=>{this.read();this.run(this.page,false);},opt);
  if(this.input.value||new URL(location.href).searchParams.has('sn_page'))this.run(this.page,false);
 }
 setMode(){const active=!!this.input.value.trim()&&(!!this.dataset.scope||this.dataset.searchMembershipOnly==='true');const old=this.sort.value;const opts=active?[{value:'relevance',text:this.messages.relevance},...this.normalOptions.filter(o=>o.value.startsWith('price-'))]:this.normalOptions;this.sort.replaceChildren(...opts.map(o=>new Option(o.text,o.value)));this.sort.value=opts.some(o=>o.value===old)?old:(active?'relevance':this.dataset.defaultSort);}
 read(){const p=new URL(location.href).searchParams;this.input.value=(p.get('sn_q')||'').slice(0,120);this.setMode();const sort=p.get('sort_by');if([...this.sort.options].some(o=>o.value===sort))this.sort.value=sort;this.page=Math.max(1,parseInt(p.get('sn_page')||p.get('page')||'1',10)||1);}
 async request(url){const response=await fetch(url,{credentials:'same-origin',signal:AbortSignal.any([this.events.signal,AbortSignal.timeout(25000)])});if(!response.ok)throw new Error('Unavailable');return response;}
 async searchPage(q,sort,page){
  const key=JSON.stringify([q,sort]);let state=this.cache.get(key);
  if(!state){state={items:[],next:true,sourcePage:1,seen:new Set()};this.cache.set(key,state);}
  if(state.pending)await state.pending;
  state.pending=(async()=>{while(state.next&&state.items.length<=page*24){
   const scoped=!!this.dataset.scope||this.dataset.searchMembershipOnly==='true';const u=new URL(scoped?this.dataset.searchUrl:this.dataset.url,location.origin);u.searchParams.set('view',scoped?'sn-secondary-search':'sn-secondary-data');u.searchParams.set('page',state.sourcePage);u.searchParams.set('sort_by',sort==='relevance'&&!scoped?this.dataset.defaultSort:sort);
   if(scoped){const words=q.split(/\s+/).filter(Boolean).map(t=>'title:'+JSON.stringify(t)).join(' AND ');u.searchParams.set('q',this.dataset.scope?this.dataset.scope+' AND ('+words+')':words);u.searchParams.set('type','product');u.searchParams.set('options[unavailable_products]','show');u.searchParams.set('options[prefix]','last');}
   const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)u.searchParams.set('preview_theme_id',preview);
   const data=await(await this.request(u)).json();if(!Array.isArray(data.products))throw new Error('Invalid response');
   for(const item of data.products){const belongs=!scoped||item.collections.includes(this.dataset.handle);const matches=scoped||q.toLowerCase().split(/\s+/).every(t=>item.title.toLowerCase().includes(t));if(belongs&&matches&&!state.seen.has(item.id)){state.seen.add(item.id);state.items.push(item);}}
   state.next=!!data.next;state.sourcePage++;
  }})();try{await state.pending;}finally{state.pending=null;}
  return {items:state.items.slice((page-1)*24,page*24),hasNext:state.items.length>page*24||state.next};
 }
 async run(page=1,historyUpdate=true){
  const seq=++this.sequence;this.page=page;const q=this.input.value.trim();const sort=this.sort.value;this.retry.hidden=true;this.clear.hidden=!q;
  if(historyUpdate){const u=new URL(location.href);u.searchParams.delete('page');for(const [k,v]of Object.entries({sn_q:q,sort_by:sort,sn_page:page>1?String(page):''})){if(v)u.searchParams.set(k,v);else u.searchParams.delete(k);}if(u.href!==location.href)history.pushState({},'',u);}
  this.content.setAttribute('aria-busy','true');this.status.textContent=this.messages.loading;
  try{if(!q){const u=new URL(this.dataset.url,location.origin);u.searchParams.set('sort_by',sort);u.searchParams.set('page',page);const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)u.searchParams.set('preview_theme_id',preview);const html=await(await this.request(u)).text();if(seq!==this.sequence)return;const result=new DOMParser().parseFromString(html,'text/html').querySelector('[data-secondary-content]');if(!result)throw new Error('Missing collection');this.content.innerHTML=result.innerHTML;}
   else{const result=await this.searchPage(q,sort,page);if(seq!==this.sequence)return;this.render(result.items,page,result.hasNext?page+1:page);}this.status.textContent='';}
  catch(e){if(seq===this.sequence){this.status.textContent=this.messages.error;this.retry.hidden=false;}}
  finally{if(seq===this.sequence)this.content.setAttribute('aria-busy','false');}
 }
 el(tag,cls,text){const e=document.createElement(tag);if(cls)e.className=cls;if(text)e.textContent=text;return e;}
 render(products,page,pages){
  const grid=this.el('div','sn-secondary-grid');for(const p of products){const template=document.createElement('template');template.innerHTML=p.html;grid.append(template.content);}
  if(!products.length){const empty=this.el('div','sn-secondary-empty');empty.append(this.el('h2','',this.messages.empty),this.el('p','',this.messages.help));const clear=this.el('button','',this.messages.clear);clear.type='button';clear.dataset.secondaryClear='';empty.append(clear);grid.append(empty);}
  const nav=this.el('nav','sn-secondary-pagination');nav.setAttribute('aria-label',this.messages.pagination);const button=(n,text)=>{const b=this.el('button','',text);b.type='button';b.dataset.secondaryPage=n;return b;};if(page>1)nav.append(button(page-1,this.messages.previous));if(pages>1)nav.append(this.el('span','',this.messages.page.replace('__PAGE__',page)));if(page<pages)nav.append(button(page+1,this.messages.next));this.content.replaceChildren(grid,nav);
 }
 disconnectedCallback(){this.events?.abort();this.ready=false;}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sn-shop-collection"] && !Shopify.designMode) return;
  try {
    function snShopMatches(product, state) {
  const price = Number(product.priceRange.minVariantPrice.amount);
  if (state.min !== '' && price < Number(state.min)) return false;
  if (state.max !== '' && price > Number(state.max)) return false;
  const options = product.options || [];
  if (state.sizes.length) {
    const sizes = options.filter(option => /size|dimension|diameter|length|width|height/i.test(option.name)).flatMap(option => option.optionValues.map(value => value.name));
    const matchesSize = sizes.some(value => {
      let inches = [...value.matchAll(/(\d+(?:\.\d+)?)\s*(?:inches|inch|in\b|(?:["″]|''))/gi)].map(match => Number(match[1]));
      const dimensions = value.match(/(\d+(?:\.\d+)?)\s*[x×*]\s*(\d+(?:\.\d+)?)\s*(?:inches|inch|in\b|(?:["″]|''))/i);
      if (dimensions) inches.push(Number(dimensions[1]), Number(dimensions[2]));
      if (!inches.length) {
        inches = [...value.matchAll(/(\d+(?:\.\d+)?)\s*cm/gi)].map(match => Number(match[1]) / 2.54);
        const cm = value.match(/(\d+(?:\.\d+)?)\s*[x×*]\s*(\d+(?:\.\d+)?)\s*cm/i);
        if (cm) inches.push(Number(cm[1]) / 2.54, Number(cm[2]) / 2.54);
      }
      if (!inches.length) return false;
      const longest = Math.max(...inches);
      return state.sizes.includes(longest <= 24 ? 'small' : longest < 40 ? 'medium' : 'large');
    });
    if (!matchesSize) return false;
  }
  return true;
}

if (!customElements.get('sn-shop-collection')) {
  customElements.define('sn-shop-collection', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-shop-config]').textContent);
      this.events = new AbortController();
      this.cache = new Map();
      this.sourceCache = new Map();
      this.membershipCache = new Map();
      this.canUseInitial = !new URL(location.href).searchParams.has('page') && !new URL(location.href).searchParams.has('sort_by');
      this.initialContent = this.querySelector("[data-shop-content]").cloneNode(true);
      this.sequence = 0;
      this.content = this.querySelector('[data-shop-content]');
      this.status = this.querySelector('[data-shop-status]');
      this.drawer = this.querySelector('dialog');
      this.openButton = this.querySelector('[data-shop-open]');
      this.state = this.readState();
      const options = { signal: this.events.signal };
      this.addEventListener('click', event => {
        const category = event.target.closest('[data-shop-category]');
        if (category) {
          this.state.category = category.dataset.shopCategory;
          this.run();
          return;
        }
        const page = event.target.closest('[data-shop-page]');
        if (page) {
          event.preventDefault();
          this.run({ page: Number(page.dataset.shopPage), history: false, scroll: true });
          return;
        }
        if (event.target.closest('[data-shop-clear]')) {
          this.state = { ...this.state, q: '', min: '', max: '', sizes: [] };
          this.run();
        }
        if (event.target.closest('[data-shop-retry]')) this.run({ history: false });
        if (event.target.closest('[data-shop-open]')) {
          this.previousOverflow = document.body.style.overflow;
          this.drawer.showModal();
          document.body.style.overflow = 'hidden';
          this.openButton.setAttribute('aria-expanded', 'true');
        }
        if (event.target.closest('[data-shop-close]')) this.drawer.close();
      }, options);
      this.addEventListener('submit', event => {
        const form = event.target;
        event.preventDefault();
        if (form.matches('[data-shop-search]')) this.state.q = form.querySelector('input[type="search"]').value.trim();
        if (form.matches('[data-shop-refine]')) {
          const min = form.querySelector('[data-shop-min]');
          const max = form.querySelector('[data-shop-max]');
          max.setCustomValidity('');
          if (min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value)) {
            max.setCustomValidity(this.config.messages.invalidRange);
            max.reportValidity();
            return;
          }
          this.state.min = min.value;
          this.state.max = max.value;
        }
        this.run();
      }, options);
      this.addEventListener('change', event => {
        const input = event.target;
        if (input.matches('[data-shop-sort]')) {
          this.state.sort = input.value;
          this.run();
        }
        if (input.matches('[data-shop-size]')) {
          const form = input.closest('[data-shop-refine]');
          this.state.sizes = [...form.querySelectorAll('[data-shop-size]:checked')].map(el => el.value);
          this.run();
        }
      }, options);
      this.addEventListener('input', event => {
        if (event.target.matches('[data-shop-min], [data-shop-max]')) event.target.closest('form').querySelector('[data-shop-max]').setCustomValidity('');
      }, options);
      this.querySelector('input[type="search"]').addEventListener('search', event => {
        if (!event.target.value && this.state.q) { this.state.q = ''; this.run(); }
      }, options);
      this.drawer.addEventListener('click', event => {
        if (event.target !== this.drawer) return;
        const rect = this.drawer.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.drawer.close();
      }, options);
      this.drawer.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow || '';
        this.openButton.setAttribute('aria-expanded', 'false');
      }, options);
      window.matchMedia('(min-width: 990px)').addEventListener('change', event => {
        if (event.matches && this.drawer.open) this.drawer.close();
      }, options);
      window.addEventListener('popstate', () => { this.state = this.readState(); this.run({ history: false }); }, options);
      const cleanUrl = new URL(location.href);
      if (cleanUrl.searchParams.has('shop_color')) { cleanUrl.searchParams.delete('shop_color'); history.replaceState({}, '', cleanUrl); }
      this.run({ history: false, initial: true });
    }
    readState() {
      const params = new URL(location.href).searchParams;
      const category = params.get('shop_category');
      const validList = (key, values) => (params.get(key) || '').split(',').filter(value => values.includes(value));
      const validPrice = key => { const value = params.get(key); return value && Number.isFinite(Number(value)) && Number(value) >= 0 ? value : ''; };
      const sort = params.get('shop_sort');
      return {
        category: this.config.categories[category] ? category : 'led-neon-sign',
        q: (params.get('shop_q') || '').slice(0,120),
        min: validPrice('shop_min'), max: validPrice('shop_max'),
        sizes: validList('shop_size', ['small','medium','large']),
        sort: ['recommended','price-ascending','price-descending','created-descending'].includes(sort) ? sort : 'recommended'
      };
    }
    syncControls() {
      const searching = Boolean(this.state.q);
      if (searching && this.state.sort === 'created-descending') this.state.sort = 'recommended';
      this.querySelectorAll('[data-shop-category]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.shopCategory === this.state.category)));
      this.querySelectorAll('[data-shop-size]').forEach(input => { input.checked = this.state.sizes.includes(input.value); });
      this.querySelectorAll('[data-shop-min]').forEach(input => { input.value = this.state.min; });
      this.querySelectorAll('[data-shop-max]').forEach(input => { input.value = this.state.max; });
      this.querySelectorAll('[data-shop-sort]').forEach(input => { input.value = this.state.sort; });
      this.querySelectorAll('[data-shop-default-sort]').forEach(option => { option.textContent = searching ? this.config.messages.relevance : this.config.messages.recommended; });
      this.querySelectorAll('[data-shop-collection-sort]').forEach(option => { option.hidden = searching; option.disabled = searching; });
      const search = this.querySelector('input[type="search"]');
      search.value = this.state.q;
      search.placeholder = this.config.messages.searchPrefix + ' ' + this.categoryLabel().toLowerCase();
      this.querySelector('[data-shop-active-category]').textContent = this.categoryLabel();
      const tags = [];
      if (this.state.q) tags.push('“' + this.state.q + '”');
      if (this.state.min !== '' || this.state.max !== '') tags.push(this.config.messages.price + ': ' + (this.state.min || '0') + '–' + (this.state.max || '∞') + ' ' + this.config.currency);
      tags.push(...this.state.sizes.map(value => this.config.sizes[value]));
      this.querySelector('[data-shop-active-filters]').textContent = tags.join(' · ');
      this.querySelector('[data-shop-toolbar-clear]').hidden = !tags.length;
    }
    categoryLabel() {
      return this.querySelector('[data-shop-category="' + this.state.category + '"]').textContent.trim();
    }
    writeState() {
      const url = new URL(location.href);
      const values = { category: this.state.category === 'led-neon-sign' ? '' : this.state.category, q: this.state.q, min: this.state.min, max: this.state.max, size: this.state.sizes.join(','), sort: this.state.sort === 'recommended' ? '' : this.state.sort };
      url.searchParams.delete('shop_color');
      for (const [key,value] of Object.entries(values)) {
        if (value) url.searchParams.set('shop_' + key, value); else url.searchParams.delete('shop_' + key);
      }
      url.searchParams.delete('page');
      url.searchParams.delete('sort_by');
      if (url.href !== location.href) history.pushState({}, '', url);
    }
    async request(state, after, signal) {
      const sourceKey = JSON.stringify({ ...state, sizes: [], after });
      if (this.sourceCache.has(sourceKey)) return this.sourceCache.get(sourceKey);
      const searching = Boolean(state.q);
      const filters = [];
      if (state.min !== '' || state.max !== '') {
        const price = {};
        if (state.min !== '') price.min = Number(state.min);
        if (state.max !== '') price.max = Number(state.max);
        filters.push({ price });
      }
      let sort = 'BEST_SELLING';
      if (searching) sort = 'RELEVANCE';
      if (state.sort.startsWith('price-')) sort = 'PRICE';
      if (!searching && state.sort === 'created-descending') sort = 'CREATED';
      const reverse = state.sort === 'price-descending' || state.sort === 'created-descending';
      const variables = { after, filters, sort, reverse, country: this.config.country };
      if (searching) {
        const terms = state.q.match(/[\p{L}\p{N}]+/gu) || [];
        const words = terms.length ? terms.map(word => '"' + word + '"').join(' AND ') : '"' + state.q.replace(/["\\]/g, '') + '"';
        variables.query = state.category === 'led-neon-sign' ? words : '(' + this.config.categories[state.category] + ') AND (' + words + ')';
      } else variables.handle = state.category;
      const response = await fetch(this.config.api, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ query: searching ? this.config.searchQuery : this.config.collectionQuery, variables }), signal: AbortSignal.any([signal, AbortSignal.timeout(8000)]) });
      if (!response.ok) throw new Error('Products request failed');
      const data = await response.json();
      if (data.errors?.length) throw new Error('Products query failed');
      const result = searching ? data.data?.search : data.data?.collection?.products;
      if (!result) throw new Error('Products unavailable');
      if (searching) {
        const membership = await Promise.all(result.nodes.map(product => this.inCategory(product, state.category, signal)));
        result.nodes = result.nodes.filter((product, index) => membership[index]);
      }
      this.sourceCache.set(sourceKey, result);
      if (this.sourceCache.size > 32) this.sourceCache.delete(this.sourceCache.keys().next().value);
      return result;
    }
    async inCategory(product, category, signal) {
      const key = product.id + ':' + category;
      if (this.membershipCache.has(key)) return this.membershipCache.get(key);
      let page = product.collections;
      if (!page) throw new Error('Collection membership unavailable');
      while (!page.nodes.some(collection => collection.handle === category) && page.pageInfo.hasNextPage) {
        const response = await fetch(this.config.api, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ query: this.config.membershipQuery, variables: { id: product.id, after: page.pageInfo.endCursor, country: this.config.country } }), signal: AbortSignal.any([signal, AbortSignal.timeout(8000)]) });
        if (!response.ok) throw new Error('Collection membership request failed');
        const data = await response.json();
        if (data.errors?.length || !data.data?.product?.collections) throw new Error('Collection membership unavailable');
        page = data.data.product.collections;
      }
      const matches = page.nodes.some(collection => collection.handle === category);
      this.membershipCache.set(key, matches);
      if (this.membershipCache.size > 256) this.membershipCache.delete(this.membershipCache.keys().next().value);
      return matches;
    }
    renderPending() {
      const grid = this.element('div', 'sn-shop-grid sn-shop-skeleton');
      grid.setAttribute('aria-hidden', 'true');
      for (let i = 0; i < 6; i++) {
        const card = this.element('div', 'sn-shop-card');
        card.append(this.element('div', 'sn-shop-card__image'), this.element('div', 'sn-shop-skeleton__line'));
        grid.append(card);
      }
      this.content.replaceChildren(grid);
    }
    async run({ page = 1, history: updateHistory = true, scroll = false, initial = false } = {}) {
      this.pending?.abort();
      clearTimeout(this.loadingTimer);
      const controller = new AbortController();
      this.pending = controller;
      const sequence = ++this.sequence;
      this.syncControls();
      if (updateHistory) this.writeState();
      const state = structuredClone(this.state);
      const key = JSON.stringify(state);
      const isDefault = state.category === 'led-neon-sign' && !state.q && state.min === '' && state.max === '' && !state.sizes.length && state.sort === 'recommended';
      const initialUrl = new URL(location.href);
      if (this.canUseInitial && isDefault && page === 1 && !initialUrl.searchParams.has('page') && !initialUrl.searchParams.has('sort_by')) {
        if (!initial) this.content.replaceChildren(...[...this.initialContent.childNodes].map(node => node.cloneNode(true)));
        this.status.textContent = '';
        this.dataset.loading = 'false';
        this.dataset.notice = 'false';
        this.content.setAttribute('aria-busy', 'false');
        this.querySelector('[data-shop-retry]').hidden = true;
        return;
      }
      let record = this.cache.get(key);
      if (!record) {
        record = { products: [], seen: new Set(), after: null, more: true };
        this.cache.set(key, record);
        if (this.cache.size > 8) this.cache.delete(this.cache.keys().next().value);
      }
      const start = (page - 1) * 24;
      const show = () => this.renderProducts(record.products.slice(start, start + 24), page, record.products.length > start + 24 || record.more, record.more && record.products.length < page * 24);
      this.dataset.notice = 'false';
      this.status.textContent = '';
      this.querySelector('[data-shop-retry]').hidden = true;
      if (record.products.length > start || !record.more) show(); else this.renderPending();
      this.content.setAttribute('aria-busy', 'true');
      this.dataset.loading = 'true';
      this.loadingTimer = setTimeout(() => {
        if (sequence === this.sequence) this.status.textContent = this.config.messages.loading.replace('__CATEGORY__', this.categoryLabel());
      }, 250);
      const started = performance.now();
      const signal = AbortSignal.any([controller.signal, AbortSignal.timeout(10000)]);
      let batches = 0;
      try {
        while (record.products.length < page * 24 && record.more && batches < 3) {
          const result = await this.request(state, record.after, signal);
          if (sequence !== this.sequence) return;
          for (const product of result.nodes) {
            if (!record.seen.has(product.id) && snShopMatches(product, state)) {
              record.seen.add(product.id);
              record.products.push(product);
            }
          }
          record.after = result.pageInfo.endCursor;
          record.more = result.pageInfo.hasNextPage;
          batches++;
          if (record.products.length > start) show();
          if (record.products.length > start && performance.now() - started >= 2500) break;
        }
        if (sequence !== this.sequence) return;
        show();
        const incomplete = record.more && record.products.length < page * 24;
        this.status.textContent = incomplete ? this.config.messages.partial : this.config.messages.updated;
        this.dataset.notice = String(incomplete);
        if (scroll) this.querySelector('.sn-shop-results').scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (error) {
        if (sequence !== this.sequence || controller.signal.aborted) return;
        if (record.products.length > start) show(); else this.content.replaceChildren();
        this.status.textContent = this.config.messages.error;
        this.querySelector('[data-shop-retry]').hidden = false;
        this.dataset.notice = 'true';
      } finally {
        if (sequence === this.sequence) {
          clearTimeout(this.loadingTimer);
          this.content.setAttribute('aria-busy', 'false');
          this.dataset.loading = 'false';
        }
      }
    }
    element(tag, className, text) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text) element.textContent = text;
      return element;
    }
    renderProducts(products, page, more, incomplete = false) {
      const grid = this.element('div', 'sn-shop-grid');
      for (const [index,product] of products.entries()) {
        const card = this.element('article', 'sn-shop-card');
        const url = this.config.productRoot + encodeURIComponent(product.handle);
        const picture = this.element('a', 'sn-shop-card__image');
        picture.href = url;
        picture.setAttribute('aria-label', product.title);
        if (product.featuredImage) {
          const img = document.createElement('img');
          img.src = product.featuredImage.url;
          img.alt = product.featuredImage.altText || product.title;
          img.width = product.featuredImage.width || 800;
          img.height = product.featuredImage.height || 800;
          img.loading = index < 3 ? 'eager' : 'lazy';
          img.decoding = 'async';
          img.sizes = '(max-width: 767px) calc((100vw - 44px)/2), (max-width: 989px) 31vw, 25vw';
          img.srcset = [320,480,640,800].map(width => { const src = new URL(product.featuredImage.url); src.searchParams.set('width', width); return src.href + ' ' + width + 'w'; }).join(', ');
          picture.append(img);
        }
        const title = this.element('a', 'sn-shop-card__title', product.title);
        title.href = url;
        const min = product.priceRange.minVariantPrice;
        const max = product.priceRange.maxVariantPrice;
        const formatted = new Intl.NumberFormat(this.config.locale, { style: 'currency', currency: min.currencyCode }).format(Number(min.amount));
        const price = this.element('p', 'sn-shop-card__price', (Number(min.amount) < Number(max.amount) ? this.config.messages.from + ' ' : '') + formatted + ' ' + min.currencyCode);
        card.append(picture, title, price);
        grid.append(card);
      }
      if (!products.length && !incomplete) {
        const empty = this.element('div', 'sn-shop-empty');
        empty.append(this.element('h2','',this.config.messages.emptyTitle), this.element('p','',this.config.messages.emptyText));
        const clear = this.element('button', 'sn-shop-clear', this.config.messages.clear);
        clear.type = 'button';
        clear.setAttribute('data-shop-clear', '');
        empty.append(clear);
        grid.append(empty);
      }
      const nav = this.element('nav', 'sn-shop-pagination');
      nav.setAttribute('aria-label', this.config.messages.pagination);
      const pageButton = (number,label) => { const button = this.element('button','',label); button.type = 'button'; button.dataset.shopPage = number; return button; };
      if (page > 1) nav.append(pageButton(page-1,this.config.messages.previous));
      if (page > 1 || more) nav.append(this.element('span','',this.config.messages.page.replace('__PAGE__',String(page))));
      if (incomplete) nav.append(pageButton(page, this.config.messages.continue));
      else if (more) nav.append(pageButton(page+1,this.config.messages.next));
      this.content.replaceChildren(grid,nav);
    }
    disconnectedCallback() {
      this.pending?.abort();
      this.events?.abort();
      clearTimeout(this.loadingTimer);
      if (this.drawer?.open) { this.drawer.close(); document.body.style.overflow = this.previousOverflow || ''; }
      this.initialized = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sn-usb-collection"] && !Shopify.designMode) return;
  try {
    function snUsbMatches(product, state) {
  const options = product.options || [];
  if (state.q && !state.q.toLowerCase().split(/\s+/).every(word => product.title.toLowerCase().includes(word))) return false;
  if (state.colors.length) {
    const colors = options.filter(o => /colou?r/i.test(o.name)).flatMap(o => o.values).map(v => String(v).trim().toLowerCase());
    if (!state.colors.some(color => colors.includes(color) || (color === 'cyan' && colors.includes('azure')))) return false;
  }
  if (state.sizes.length) {
    const matches = options.flatMap(o => o.values).some(raw => {
      const value = String(raw).replace(/[‘’]/g,"'");
      let inches = [...value.matchAll(/(\d+(?:\.\d+)?)\s*(?:inches|inch|in\b|["″]|'')/gi)].map(m => +m[1]);
      const pair = value.match(/(\d+(?:\.\d+)?)\s*[x×*]\s*(\d+(?:\.\d+)?)\s*(?:inches|inch|in\b|["″]|'')/i);
      if (pair) inches.push(+pair[1],+pair[2]);
      if (!inches.length) {
        inches = [...value.matchAll(/(\d+(?:\.\d+)?)\s*cm/gi)].map(m=>+m[1]/2.54);
        const cm = value.match(/(\d+(?:\.\d+)?)\s*[x×*]\s*(\d+(?:\.\d+)?)\s*cm/i);
        if(cm) inches.push(+cm[1]/2.54,+cm[2]/2.54);
      }
      if(!inches.length) return false;
      const longest=Math.max(...inches);
      return state.sizes.includes(longest<=13.01?'small':longest<=20.01?'medium':'large');
    });
    if(!matches) return false;
  }
  return true;
}
if (!customElements.get('sn-usb-collection')) customElements.define('sn-usb-collection', class extends HTMLElement {
  connectedCallback() {
    if(this.initialized) return;
    this.initialized=true;
    this.events=new AbortController();
    this.config=JSON.parse(this.querySelector('[data-usb-config]').textContent);
    this.content=this.querySelector('[data-usb-content]');
    this.initialContent=this.content.cloneNode(true);
    this.status=this.querySelector('[data-usb-status]');
    this.drawer=this.querySelector('dialog');
    this.openButton=this.querySelector('[data-usb-open]');
    this.sequence=0;
    this.state=this.readState();
    const opt={signal:this.events.signal};
    this.addEventListener('submit',e=>{e.preventDefault();if(e.target.matches('[data-usb-search]'))this.state.q=e.target.querySelector('input').value.trim();this.run();},opt);
    this.addEventListener('change',e=>{
      if(e.target.matches('[data-usb-sort]'))this.state.sort=e.target.value;
      else if(e.target.matches('[data-usb-color],[data-usb-size]')) {
        const kind=e.target.matches('[data-usb-color]')?'color':'size';
        this.state[kind+'s']=[...e.target.closest('form').querySelectorAll('[data-usb-'+kind+']:checked')].map(x=>x.value);
      } else return;
      this.run();
    },opt);
    this.addEventListener('click',e=>{
      const page=e.target.closest('[data-usb-page]');
      if(page){e.preventDefault();this.run({page:Number(page.dataset.usbPage),scroll:true});}
      if(e.target.closest('[data-usb-clear]')){this.state={q:'',colors:[],sizes:[],sort:'recommended',page:1};this.run();}
      if(e.target.closest('[data-usb-retry]'))this.run();
      if(e.target.closest('[data-usb-open]')){this.previousOverflow=document.body.style.overflow;this.drawer.showModal();document.body.style.overflow='hidden';this.openButton.setAttribute('aria-expanded','true');}
      if(e.target.closest('[data-usb-close]'))this.drawer.close();
    },opt);
    this.drawer.addEventListener('close',()=>{document.body.style.overflow=this.previousOverflow||'';this.openButton.setAttribute('aria-expanded','false');this.openButton.focus();},opt);
    this.querySelector('input[type="search"]').addEventListener('search',e=>{if(!e.target.value){this.state.q='';this.run();}},opt);
    window.addEventListener('popstate',()=>{this.state=this.readState();this.run({page:this.state.page,history:false});},opt);
    window.matchMedia('(min-width:990px)').addEventListener('change',e=>{if(e.matches&&this.drawer.open)this.drawer.close();},opt);
    this.run({page:this.state.page,history:false,initial:true});
  }
  readState(){
    const p=new URL(location.href).searchParams;
    return {q:(p.get('usb_q')||'').slice(0,120),colors:(p.get('usb_color')||'').split(',').filter(x=>this.config.colors[x]),sizes:(p.get('usb_size')||'').split(',').filter(x=>this.config.sizes[x]),sort:['price-ascending','price-descending','created-descending'].includes(p.get('usb_sort'))?p.get('usb_sort'):'recommended',page:Math.max(1,Number(p.get('usb_page')||1)||1)};
  }
  sync(){
    this.querySelectorAll('[data-usb-color]').forEach(x=>x.checked=this.state.colors.includes(x.value));
    this.querySelectorAll('[data-usb-size]').forEach(x=>x.checked=this.state.sizes.includes(x.value));
    this.querySelectorAll('[data-usb-sort]').forEach(x=>x.value=this.state.sort);
    this.querySelector('input[type="search"]').value=this.state.q;
    const tags=[this.state.q,...this.state.colors.map(x=>this.config.colors[x]),...this.state.sizes.map(x=>this.config.sizes[x])].filter(Boolean);
    this.querySelector('[data-usb-active-filters]').textContent=tags.join(' · ');
    this.querySelector('[data-usb-toolbar-clear]').hidden=!tags.length;
  }
  async loadProducts(){
    if(this.products)return this.products;
    if(this.loadingProducts)return this.loadingProducts;
    this.loadingProducts=(async()=>{
      const products=[];let next=this.config.dataUrl;
      while(next){
        const url=new URL(next,location.origin);url.searchParams.set('view','sn-usb-data');
        const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
        const response=await fetch(url,{credentials:'same-origin',signal:AbortSignal.any([this.events.signal,AbortSignal.timeout(12000)])});
        if(!response.ok)throw new Error('Products unavailable');
        const data=await response.json();
        products.push(...data.products);next=data.next;
      }
      this.products=products.map(p=>({...p,featuredImage:p.image?{url:p.image}:null,priceRange:{minVariantPrice:{amount:p.min,currencyCode:this.config.currency},maxVariantPrice:{amount:p.max,currencyCode:this.config.currency}}}));
      return this.products;
    })();
    try{return await this.loadingProducts;}finally{this.loadingProducts=null;}
  }
  async run({page=1,history:update=true,scroll=false,initial=false}={}){
    const seq=++this.sequence;this.state.page=page;this.sync();
    if(update){
      const u=new URL(location.href);for(const [k,v] of Object.entries({q:this.state.q,color:this.state.colors.join(','),size:this.state.sizes.join(','),sort:this.state.sort==='recommended'?'':this.state.sort,page:page>1?String(page):''})){if(v)u.searchParams.set('usb_'+k,v);else u.searchParams.delete('usb_'+k);}u.searchParams.delete('page');u.searchParams.delete('sort_by');if(u.href!==location.href)window.history.pushState({},'',u);
    }
    this.querySelector('[data-usb-retry]').hidden=true;
    this.status.textContent='';this.dataset.notice='false';
    if(!this.state.q&&!this.state.colors.length&&!this.state.sizes.length&&this.state.sort==='recommended'&&page===1&&!new URL(location.href).searchParams.has('page')){
      if(!initial)this.content.replaceChildren(...[...this.initialContent.childNodes].map(x=>x.cloneNode(true)));
      this.dataset.loading='false';this.content.setAttribute('aria-busy','false');return;
    }
    this.dataset.loading='true';this.content.setAttribute('aria-busy','true');
    const timer=setTimeout(()=>{if(seq===this.sequence)this.status.textContent=this.config.messages.loading.replace('__CATEGORY__','USB neon signs');},350);
    try{
      let products=(await this.loadProducts()).filter(p=>snUsbMatches(p,this.state));if(seq!==this.sequence)return;
      if(this.state.sort==='price-ascending')products.sort((a,b)=>a.min-b.min);
      if(this.state.sort==='price-descending')products.sort((a,b)=>b.min-a.min);
      if(this.state.sort==='created-descending')products.sort((a,b)=>Number(b.created)-Number(a.created));
      const start=(page-1)*24;this.renderProducts(products.slice(start,start+24),page,products.length>start+24);
      this.status.textContent=this.config.messages.updated;
      if(scroll)this.querySelector('.sn-usb-results').scrollIntoView({behavior:'smooth',block:'start'});
    }catch(e){console.error('USB collection:',e);if(seq===this.sequence){this.status.textContent=this.config.messages.error;this.dataset.notice='true';this.querySelector('[data-usb-retry]').hidden=false;}}
    finally{clearTimeout(timer);if(seq===this.sequence){this.dataset.loading='false';this.content.setAttribute('aria-busy','false');}}
  }
    element(tag, className, text) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text) element.textContent = text;
      return element;
    }
    renderProducts(products, page, more, incomplete = false) {
      const grid = this.element('div', 'sn-usb-grid');
      for (const [index,product] of products.entries()) {
        const card = this.element('article', 'sn-usb-card');
        const url = this.config.productRoot + encodeURIComponent(product.handle);
        const picture = this.element('a', 'sn-usb-card__image');
        picture.href = url;
        picture.setAttribute('aria-label', product.title);
        if (product.featuredImage) {
          const img = document.createElement('img');
          img.src = product.featuredImage.url;
          img.alt = product.featuredImage.altText || product.title;
          img.width = product.featuredImage.width || 800;
          img.height = product.featuredImage.height || 800;
          img.loading = index < 3 ? 'eager' : 'lazy';
          img.decoding = 'async';
          img.sizes = '(max-width: 767px) calc((100vw - 44px)/2), (max-width: 989px) 31vw, 25vw';
          img.srcset = [320,480,640,800].map(width => { const src = new URL(product.featuredImage.url, location.origin); src.searchParams.set('width', width); return src.href + ' ' + width + 'w'; }).join(', ');
          picture.append(img);
        }
        const title = this.element('a', 'sn-usb-card__title', product.title);
        title.href = url;
        const min = product.priceRange.minVariantPrice;
        const max = product.priceRange.maxVariantPrice;
        const formatted = new Intl.NumberFormat(this.config.locale, { style: 'currency', currency: min.currencyCode }).format(Number(min.amount));
        const price = this.element('p', 'sn-usb-card__price', (Number(min.amount) < Number(max.amount) ? this.config.messages.from + ' ' : '') + formatted + ' ' + min.currencyCode);
        card.append(picture, title, price);
        grid.append(card);
      }
      if (!products.length && !incomplete) {
        const empty = this.element('div', 'sn-usb-empty');
        empty.append(this.element('h2','',this.config.messages.emptyTitle), this.element('p','',this.config.messages.emptyText));
        const clear = this.element('button', 'sn-usb-clear', this.config.messages.clear);
        clear.type = 'button';
        clear.setAttribute('data-usb-clear', '');
        empty.append(clear);
        grid.append(empty);
      }
      const nav = this.element('nav', 'sn-usb-pagination');
      nav.setAttribute('aria-label', this.config.messages.pagination);
      const pageButton = (number,label) => { const button = this.element('button','',label); button.type = 'button'; button.dataset.usbPage = number; return button; };
      if (page > 1) nav.append(pageButton(page-1,this.config.messages.previous));
      if (page > 1 || more) nav.append(this.element('span','',this.config.messages.page.replace('__PAGE__',String(page))));
      if (incomplete) nav.append(pageButton(page, this.config.messages.continue));
      else if (more) nav.append(pageButton(page+1,this.config.messages.next));
      this.content.replaceChildren(grid,nav);
    }

  disconnectedCallback(){this.events?.abort();if(this.drawer?.open){this.drawer.close();document.body.style.overflow=this.previousOverflow||'';}this.initialized=false;}
});
  } catch(e) { console.error(e); }
})();

})();
